import styled from 'styled-components';

export const HeaderWrapper = styled.header`
  box-shadow: rgb(100 116 139 / 12%) 0px 1px 4px;
  background-color: #fff;

  .inner {
    padding: 13px 0px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    h3 {
      margin: 0;
      font-size: 17px;
    }
  }
`;
